jQuery(function($){

    $('.featured-image__container').on('click', function () {
        generatePopUpGallery($(this).find('img'));
    });

    $('.product-gallery-slider').on('click', function () {
        generatePopUpGallery($(this).find('.slick-slide').find('img'));
    });

    function generatePopUpGallery(clicked_image){
        const gallery = $('.pop-up-gallery');

        //if ( $(window).width() > 767 ) {
            let current_image = clicked_image.data('nr');
            //if ( !gallery.hasClass('loaded') && gallery.length > 0 ) {

                // If gallery is not loaded, load gallery from slick slider.

                // Generate gallery inner structure.
                let inner_html = '<div class="image-slider"><div class="close"></div><div class="slider-arrow slider-prev"></div><div class="slider-arrow slider-next"></div></div><div class="thumbnail-slider"></div>';
                gallery.find('.pop-up-gallery__inner').append(inner_html);

                // generate images from slick slider.
                let slick_images = clicked_image.parents('.slick-initialized').find('img:not(.slick-cloned)');
                let image_count = slick_images.length;

                gallery.find('.image-slider .slider-prev').after(slick_images.clone());
                let images = gallery.find('img');
                images.removeClass().css('width', '100%').removeAttr('data-slick-index').removeAttr('tabindex').each(function () {
                    $(this).attr('style', function(i, style)
                    {
                        return style && style.replace(/display[^;]+;?/g, '');
                    });
                    $(this).addClass('image-' + $(this).data('nr'));
                });
                gallery.find('.image-slider img[data-nr="' + current_image + '"]').addClass('active');

                if ( image_count > 1 ) {
                    // Generate thumbnail slider images and its HTML
                    let images_per_page = 7;
                    let pages = Math.floor(image_count / images_per_page);
                    let modulus = image_count % images_per_page;
                    if ( modulus !== 0 ) {
                        pages++;
                    }
                    let html = '';

                    for ( let i = 0; i < pages; i++ ) {
                        html += '<div class="slide slide-' + (i + 1) + '" data-nr="' + (i + 1) + '">';

                        for ( let j = i * images_per_page; j < images_per_page * (i + 1); j++ ) {

                            html += '<div class="img-wrapper">';
                            html += images[j].outerHTML;
                            html += '</div>';

                            if ( j >= image_count - 1 ) {
                                break;
                            }
                        }

                        html += '</div>';
                    }

                    html += '<div class="thumbnail-slider__dots">';
                    for ( let i = 1; i <= pages; i++ ) {
                        html += '<div class="slider-dot slider-dot-' + i + '" data-nr="' + i + '"><div class="inner"></div></div>';
                    }
                    html += '</div>';

                    gallery.find('.thumbnail-slider').html(html).find('img.active').parent().addClass('active').parent().addClass('active-slide');
                    let active_slide = gallery.find('.thumbnail-slider .slide.active-slide').data('nr');
                    gallery.find('.thumbnail-slider .thumbnail-slider__dots .slider-dot-' + active_slide).addClass('active');

                } else {
                    gallery.find('.image-slider img').addClass('active');
                    gallery.addClass('no-slider');
                }

                gallery.addClass('loaded');

            /*} else {

                // If gallery is loaded, change active classes
                gallery.find('.image-slider img').removeClass('active');
                gallery.find('.thumbnail-slider .slide').removeClass('active-slide');
                gallery.find('.thumbnail-slider .img-wrapper').removeClass('active');
                gallery.find('.thumbnail-slider .img-wrapper img').removeClass('active');
                gallery.find('.thumbnail-slider .thumbnail-slider__dots .slider-dot').removeClass('active');

                gallery.find('.image-slider img[data-nr="' + current_image + '"]').addClass('active');
                gallery.find('.thumbnail-slider img[data-nr="' + current_image + '"]').parent().addClass('active').parent().addClass('active-slide');
                let active_slide = gallery.find('.thumbnail-slider .slide.active-slide').data('nr');
                gallery.find('.thumbnail-slider .thumbnail-slider__dots .slider-dot-' + active_slide).addClass('active');

            }*/

            gallery.show();
        //}
    }

    $('.pop-up-gallery ').on('click', function(e){
        let elm = e.target;

        if( $(elm).hasClass('pop-up-gallery') || $(elm).hasClass('pop-up-gallery__inner') ){
            $(this).find('.pop-up-gallery__inner').empty();
            $(this).hide();
        }
    });

    $('.pop-up-gallery__inner').on('click', '.close', function() {
        const gallery = $('.pop-up-gallery');

        gallery.find('.pop-up-gallery__inner').empty();
        gallery.hide();
    }).on('click', '.slider-next', function() {
        $(this).siblings('img').each(function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

                if ($(this).next('img').length > 0) {
                    $(this).next('img').addClass('active');
                } else {
                    $(this).siblings('img').first().addClass('active');
                }
                return false;
            }
        });

        $('.img-wrapper').each(function(i) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

                let next = $('.img-wrapper').eq(i + 1);
                if (next.length > 0) {
                    next.addClass('active');

                    if (!$(this).parent().is(next.parent())) {
                        $('.thumbnail-slider .slide').removeClass('active-slide');
                        next.parent().addClass('active-slide');

                        let slide = next.parent().data('nr');
                        $('.thumbnail-slider__dots .slider-dot').removeClass('active');
                        $('.thumbnail-slider__dots').find('.slider-dot-' + slide).addClass('active');
                    }
                } else {
                    $('.thumbnail-slider .slide').removeClass('active-slide');
                    $('.img-wrapper').first().addClass('active').parent().addClass('active-slide');
                    $('.thumbnail-slider__dots .slider-dot').removeClass('active').first().addClass('active');
                }
                return false;
            }
        });
    }).on('click', '.slider-prev', function() {
        $(this).siblings('img').each(function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

                if ($(this).prev('img').length > 0) {
                    $(this).prev('img').addClass('active');
                } else {
                    $(this).siblings('img').last().addClass('active');
                }
                return false;
            }
        });

        $('.img-wrapper').each(function(i) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

                let prev = $('.img-wrapper').eq(i - 1);
                if (prev.length > 0) {
                    prev.addClass('active');

                    if (!$(this).parent().is(prev.parent())) {
                        $('.thumbnail-slider .slide').removeClass('active-slide');
                        prev.parent().addClass('active-slide');

                        let slide = prev.parent().data('nr');
                        $('.thumbnail-slider__dots .slider-dot').removeClass('active');
                        $('.thumbnail-slider__dots').find('.slider-dot-' + slide).addClass('active');
                    }
                } else {
                    $('.thumbnail-slider .slide').removeClass('active-slide');
                    $('.img-wrapper').last().addClass('active').parent().addClass('active-slide');
                    $('.thumbnail-slider__dots .slider-dot').removeClass('active').last().addClass('active');
                }
                return false;
            }
        });
    }).on('click', '.img-wrapper', function() {
        let image = $(this).find('img').data('nr');

        $('.img-wrapper').removeClass('active');

        $(this).addClass('active');
        $('.pop-up-gallery__inner .image-slider').find('img').removeClass('active').each(function() {
            if ($(this).hasClass('image-' + image)) {
                $(this).addClass('active');
                return false;
            }
        });
    }).on('click', '.thumbnail-slider__dots .slider-dot', function() {
        $('.thumbnail-slider__dots .slider-dot').removeClass('active');
        $(this).addClass('active');
        let slide = $(this).data('nr');
        $('.thumbnail-slider .slide').removeClass('active-slide');
        $('.thumbnail-slider').find('.slide.slide-' + slide).addClass('active-slide');
    });
});




